import { render, staticRenderFns } from "./koluserlayout.vue?vue&type=template&id=56edbe19&"
import script from "./koluserlayout.vue?vue&type=script&lang=js&"
export * from "./koluserlayout.vue?vue&type=script&lang=js&"
import style0 from "./koluserlayout.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports